import { ReactNode } from "react";

import { CourseRole, OrgRole, SectionRole, UserRole } from "../../../../../shared/types/roles";

import { t } from "i18n/i18n";
import { TooltipTrigger } from "mds/components/TooltipTrigger";
import {
  PersonCourseAdminIcon,
  PersonSingleIcon,
  PersonSingleStarIcon,
  StarFilledIcon,
  StarIcon,
} from "mds/icons";

export type ExtendedOrgRoleType = UserRole | OrgRole | CourseRole | null;

// TODO: Combine with home roles
const ORG_ROLE_TO_ICON: Record<NonNullable<ExtendedOrgRoleType> | "other", ReactNode> = {
  [UserRole.SUPER_ADMIN]: <StarFilledIcon />,
  [UserRole.GLOBAL_ADMIN]: <StarFilledIcon />,
  [OrgRole.ADMIN]: <StarIcon />,
  [CourseRole.COURSE_ADMIN]: <PersonCourseAdminIcon />,
  other: <PersonSingleIcon />,
  [UserRole.RECORDING_AGENT]: null,
};

// eslint-disable-next-line react-refresh/only-export-components -- UI helper colocated with role icons
export const getIconFromOrgRole = (role: ExtendedOrgRoleType) => ORG_ROLE_TO_ICON[role ?? "other"];

// eslint-disable-next-line react-refresh/only-export-components
export const SECTION_ROLE_TO_ICON: Record<SectionRole, ReactNode> = {
  instructor: <StarIcon />,
  section_assistant: <PersonSingleStarIcon />,
  student: <PersonSingleIcon />,
  recording_agent: null,
};

export const OrgRoleIconWithTooltip = ({
  role,
  extraContent = null,
}: {
  role: ExtendedOrgRoleType;
  extraContent?: ReactNode;
}) => {
  const content = (
    <>
      {t(`roles.org_${role ?? "other"}_explanation`)}
      {extraContent}
    </>
  );

  return <TooltipTrigger content={content}>{getIconFromOrgRole(role)}</TooltipTrigger>;
};
